import * as React from "react";
import { AppTooltip } from "./AppTooltip";
import { getTooltipText } from "../../../utilities/getTooltipText";
import type { AppTooltipContainerProps } from "./AppTooltipContainer.types";
import { useV9TooltipEnabled } from "../../../hooks/useV9TooltipEnabled";
import { tooltipDirectionMap } from "./tooltipDirectionMap";
import type { PositioningShorthand } from "@fluentui/react-components";

export const AppTooltipContainer = (props: AppTooltipContainerProps) => {
  const isV9TooltipEnabled = useV9TooltipEnabled();
  if (isV9TooltipEnabled) {
    const { hideLabel, label, customTooltip, showTooltip = false } = props;
    const tooltipLabel = getTooltipText(hideLabel, label, customTooltip);
    if (showTooltip && tooltipLabel) {
      return (
        <AppTooltip
          tooltipVisible={props.visible}
          tooltipLabel={tooltipLabel}
          positioning={
            tooltipDirectionMap[
              props.directionalHint || 5
            ] as PositioningShorthand
          }
          elementId={props.id}
          tooltipClassName={props.tooltipClassName}
          relationship={props.relationship}
        >
          {props.children}
        </AppTooltip>
      );
    }
  }
  return <>{props.children}</>;
};
